// @flow
import { Map } from "immutable"

type SetAccepted = {|
  type: "SET_ACCEPTED",
  payload: Map,
|}

type LoadSuccessPricesPayload = {|
  basePrice: number,
  adultsPrice: number,
  childrenPrice: number,
  infantsPrice: number,
  fees: Map,
  gracePeriodFee: number,
  accepted: Map,
  holdBagsPricingCurrent: Map<string, number>,
|}

type LoadSuccessPrices = {|
  type: "LOAD_SUCCESS_PRICES",
  payload: LoadSuccessPricesPayload,
|}

type UpdateSuccessPricesPayload = {|
  fees: Map,
  basePrice: number,
  adultsPrice: number,
  childrenPrice: number,
  infantsPrice: number,
  accepted: Map,
|}
type UpdateSuccessPrices = {|
  type: "UPDATE_SUCCESS_PRICES",
  payload: UpdateSuccessPricesPayload,
|}

type SaveSuccessPricesPayload = {|
  shameBagsPrice: number,
  shameFinalPriceInCurrency: number,
|}
type SaveSuccessPrices = {|
  type: "SAVE_SUCCESS_PRICES",
  payload: SaveSuccessPricesPayload,
|}

export type Action = SetAccepted | LoadSuccessPrices | UpdateSuccessPrices | SaveSuccessPrices

export const setAccepted = (accepted: Map): SetAccepted => ({
  type: "SET_ACCEPTED",
  payload: accepted,
})

export const loadSuccessPrices = (payload: LoadSuccessPricesPayload): LoadSuccessPrices => ({
  type: "LOAD_SUCCESS_PRICES",
  payload,
})

export const updateSuccessPrices = (payload: UpdateSuccessPricesPayload): UpdateSuccessPrices => ({
  type: "UPDATE_SUCCESS_PRICES",
  payload,
})

export const saveSuccessPrices = (payload: SaveSuccessPricesPayload): SaveSuccessPrices => ({
  type: "SAVE_SUCCESS_PRICES",
  payload,
})
